import { render, staticRenderFns } from "./AssetManager.vue?vue&type=template&id=531f21d2&scoped=true&"
import script from "./AssetManager.vue?vue&type=script&lang=js&"
export * from "./AssetManager.vue?vue&type=script&lang=js&"
import style0 from "./AssetManager.vue?vue&type=style&index=0&id=531f21d2&lang=scss&scoped=true&"
import style1 from "./AssetManager.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f21d2",
  null
  
)

export default component.exports